import { render, staticRenderFns } from "./CoozzyMinimizeIcon.vue?vue&type=template&id=77ef85ad&scoped=true"
import script from "./CoozzyMinimizeIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyMinimizeIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyMinimizeIcon.vue?vue&type=style&index=0&id=77ef85ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef85ad",
  null
  
)

export default component.exports